import { render, staticRenderFns } from "./TaxIncentivesCostBreakdown.vue?vue&type=template&id=12c0eb7d&scoped=true"
import script from "./TaxIncentivesCostBreakdown.vue?vue&type=script&lang=js"
export * from "./TaxIncentivesCostBreakdown.vue?vue&type=script&lang=js"
import style0 from "./TaxIncentivesCostBreakdown.vue?vue&type=style&index=0&id=12c0eb7d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c0eb7d",
  null
  
)

export default component.exports